import chairmen from "../Assets/Images/chairmen.jpg";
import team1 from "../Assets/Images/team1.jpg";
import team2 from "../Assets/Images/team2.jpg";
import cabincrew1 from "../Assets/Images/cabincrew1.webp";
import cabincrew2 from "../Assets/Images/cabincrew2.jpg";
import reviewimg from "../Assets/Images/reviewImg.webp";
import serveCoffee from "../Assets/Images/noida.jpeg";
import lucknow from "../Assets/Images/lucknow.jpg";
import delhi from "../Assets/Images/delhi.jpg";
import punjab from "../Assets/Images/punjab.jpg";
import hyderabad from "../Assets/Images/hyderabad.jpg";
import husainabad from "../Assets/Images/husainabad.jpg";
import metro from "../Assets/Images/metro.jpg";
import lotus from "../Assets/Images/lotus.jpg";
import bengaluru from "../Assets/Images/bengaluru.jpg";

export const teamData = [
  {
    name: "Sharvan K Vishwakarma",
    designation: "CHAIRMAN",
    image: chairmen,
    description:
      "Leading the vision and overall strategy of the company. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur.",
  },
  // {
  //   name: "Bob Smith",
  //   designation: "CTO",
  //   image: team1,
  //   description:
  //     "Heads the tech team and innovation efforts. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur.lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur.",
  // },
  // {
  //   name: "Clara Davis",
  //   designation: "CMO",
  //   image: team2,
  //   description:
  //     "Handles marketing and brand growth.lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur.lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur.lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur.",
  // },
  // {
  //   name: "Clark Wayne",
  //   designation: "NSG",
  //   image: team1,
  //   description:
  //     "Heads the tech team and innovation efforts. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur.lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur.",
  // },
];

export const pilotData = [
  {
    name: "Captain Rajesh Kumar",
    designation: "Pilot - Airbus A320",
    image: team1,
    description:
      "Over 15 years of flight experience across international and domestic sectors. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur.",
  },
  {
    name: "Captain Nehal Sharma",
    designation: "Pilot - Boeing 737",
    image: team2,
    description:
      "Specialized in night operations and cross-state routes. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur.",
  },
];

export const cabinCrewData = [
  {
    name: "Priya Mehta",
    designation: "Senior Cabin Crew",
    image: cabincrew1,
    description:
      "Over 8 years of experience in ensuring passenger comfort and safety. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur.",
  },
  {
    name: "Aditi Singh",
    designation: "Cabin Crew",
    image: cabincrew2,
    description:
      "Specialized in first-class service and passenger assistance. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur. lorem ipsum dolor sit amet consectetur adipisicing elit. Quod, consequatur.",
  },
];

export const cityImages = {
  Delhi: [
    { src: lucknow, title: "Lucknow", btnText: "Book Now" },
    { src: delhi, title: "Bengaluru", btnText: "View More" },
    { src: serveCoffee, title: "Noida", btnText: "View More" },
    { src: bengaluru, title: "Gurgaon", btnText: "View More" },
    { src: hyderabad, title: "Hyderabad", btnText: "View More" },
  ],
  Mumbai: [
    { src: punjab, title: "Delhi", btnText: "Discover" },
    { src: husainabad, title: "Lucknow", btnText: "Discover" },
    { src: metro, title: "Varanasi", btnText: "Book Now" },
    { src: metro, title: "Noida", btnText: "Book Now" },
  ],
  Noida: [
    { src: lotus, title: "Fly to Noida", btnText: "Reserve" },
    { src: hyderabad, title: "Lucknow", btnText: "Explore" },
    { src: serveCoffee, title: "Lucknow", btnText: "Explore" },
  ],
};

export const reviews = [
  {
    id: 1,
    text: "Great service!",
    name: "Jane Smith",
    designation: "Manager",
    author:
      "The team provided outstanding service, ensuring every detail was taken care of. I was truly impressed by their professionalism and dedication to excellence. They made the entire process smooth and stress-free, leaving me with a lasting positive impression.",
    image: reviewimg,
    rating: 5,
  },
  {
    id: 2,
    text: "Amazing experience!",
    name: "Michael Lee",
    designation: "Entrepreneur",
    author:
      "From start to finish, the experience was seamless and enjoyable. The staff went above and beyond to make it memorable, paying attention to every little detail. Their commitment to customer satisfaction was evident throughout, making it an unforgettable experience.",
    rating: 4,
    image: reviewimg,
  },
  {
    id: 3,
    text: "Highly recommend!",
    name: "Alice Johnson",
    designation: "Consultant",
    author:
      "I would recommend their services to anyone. They exceeded my expectations and delivered exceptional results. Their expertise and attention to detail were remarkable, and they truly went the extra mile to ensure everything was perfect.",
    rating: 4,
    image: reviewimg,
  },
  {
    id: 4,
    text: "Will come back again!",
    name: "Bob Brown",
    designation: "Designer",
    author:
      "I had such a positive experience that I can't wait to return. The team was friendly, efficient, and highly skilled. They created an atmosphere of trust and comfort, making the entire experience enjoyable and worthwhile and That's it, that's what all i had to say.",
    rating: 5,
    image: reviewimg,
  },
];

export let mapLink = "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7120.321940505369!2d81.011774!3d26.834832!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399be30c5ffcfa33%3A0xcfa1e79bc7b34848!2sShankh%20Tower!5e0!3m2!1sen!2sin!4v1744968599009!5m2!1sen!2sin"